export default __webpack_public_path__ + "static/media/central.1fb9ece4.jpeg";